import { useEffect, useState } from "react";
import styled from "styled-components";
import { makeSafeUrl } from "./utils/serializers";
import { setLinkBlock } from "./utils/transforms";
import { useSlate } from "slate-react";

/*
      {
        type: 'link',
        url: 'https://en.wikipedia.org/wiki/Hypertext',
        children: [{ text: 'hyperlink' }],
      },
 
*/

const Container = styled.div<{$show: boolean}>`
  position: absolute;
  right: 100px;
  flex: 1;
  display: ${props => props.$show ? 'flex' : 'none'};
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-width: 2px;
  border-radius: 2px;
  border-color: #2196f3;
  border-style: dashed;
  background-color: #fafafa;
  color: #bdbdbd;
  outline: none;
  transition: border .24s ease-in-out;
  z-index: 200;
  
  .form:hover {
    box-shadow: var(--shadow-4);
  }
  .form-label {
    display: block;
    font-size: var(--smallText);
    margin-bottom: 0.1rem;
    text-transform: capitalize;
    letter-spacing: var(--letterSpacing);
  }
  .form-input {
    width: 90%;
    height: 25px;
    padding: 0rem 0.35rem;
    border-radius: var(--borderRadius);
    background: var(--backgroundColor);
    border: 1px solid var(--grey-200);
    margin-bottom: 0.5rem;
  }
  .form-row {
    display: grid;
    grid-template-columns: 1fr
  }

`;

interface LinkMakerProps {
  openDialogue: boolean
  setOpenDialogue: React.Dispatch<React.SetStateAction<boolean>>
  selectedText:string
  setSelectedText: React.Dispatch<React.SetStateAction<string>>
}
export const LinkMaker = (props: LinkMakerProps) => {
  const [targetLinkUrl, setTargetLink] = useState<string>('');
  const [canSubmit, setCanSubmit] = useState<boolean>(false);

  const editor = useSlate();

  useEffect(() => {
    // this will have its effect only when the prop value changes
    // which is when Toolbar detects the onMouseDown event on the image button
    props.setOpenDialogue(props.openDialogue);
    
  },[props,props.openDialogue])

  useEffect(() => {
    // this will have its effect only when the prop value changes
    // which is when Toolbar detects the onMouseDown event on the image button
    if (props.selectedText && targetLinkUrl) {
      setCanSubmit(true);
    }
    
  },[props,props.selectedText,targetLinkUrl])


  const handleSubmit = () => {
    props.setOpenDialogue(false);
    setLinkBlock(editor, targetLinkUrl, props.selectedText)
  }

  // link title may be passed in from selection
  return (
    <div className="container">
      <Container $show ={props.openDialogue} onClick={e => e.stopPropagation()}>
        <div className="form-row">
          <label htmlFor='Link Text' className='form-label'>
            Link Text
          </label>
          <input
            name='link.text'
            type='input'
            value={props.selectedText}
            onChange={e => props.setSelectedText(e.target.value)}
            className='form-input'
          />
        </div>
        <div className="form-row">
          <label htmlFor='Link URL' className='form-label'>
            Link URL
          </label>
          <input
            name='link.url'
            type='input'
            value={targetLinkUrl}
            onChange={e => setTargetLink(makeSafeUrl(e.target.value))}
            className='form-input'
          />
        </div>
        <div className='spread-container'>
          <button type="button" className='btn' disabled={!canSubmit} onClick={handleSubmit}>
            Add
          </button>
          <button type="button" className='btn' onClick={e => props.setOpenDialogue(false)}>
            Cancel
          </button>
        </div>

      </Container>
    </div>
  );
}
